const SYSTEM_DESTINATION_ICONS = {
  cuisine: "🍳",
  bar: "🍸",
  none: "",
};

const looksLikeTechnicalIconName = (value) =>
  /^[a-z0-9]+(?:-[a-z0-9]+)*$/i.test(String(value || "").trim());

export const getProductionDestinationIcon = (destination = {}) => {
  const code = String(destination?.code || "").trim().toLowerCase();
  const configured = String(destination?.icon || "").trim();
  if (Object.prototype.hasOwnProperty.call(SYSTEM_DESTINATION_ICONS, code)) {
    return SYSTEM_DESTINATION_ICONS[code];
  }
  if (!configured || looksLikeTechnicalIconName(configured)) return "🖥️";
  return configured;
};

export const getProductionDestinationLabel = (destination = {}) => {
  const icon = getProductionDestinationIcon(destination);
  const name = String(destination?.name || destination?.code || "Destination").trim();
  return icon ? `${icon} ${name}` : name;
};
